// src/components/Footer.js
import React from "react";
import logo from "../assets/img/logo/logo.jpeg";

const Footer = () => {
  return (
    <footer id="footer" className="footer dark-background">
      <div className="container">
        <div className="row gy-5">
          {/* Footer About */}
          <div className="col-lg-4 col-md-6 footer-about">
            {/* <a href="#hero" className="logo d-flex align-items-center mb-3">
              <span className="sitename">Cart Studio</span>
            </a> */}
            <a href="/" className="logo d-flex align-items-center mb-3">
              <img
                src={logo}
                alt="CART STUDIO Logo"
                className="rounded   object-fit-cover me-2"
                style={{ height: "90px", width: "90px" }}
              />
              <h1 className="sitename mb-0 h5">CART STUDIO</h1>
            </a>
            <p>A-46, Sector-A4, UPSIDC, Tronica City, Loni, Ghaziabad, U.P.</p>
            <p>
              <a href="tel:+911202696245" className="text-success fw-bold">
                +91-120-2696245
              </a>
              ,
              <a href="tel:+917836996855" className="text-success fw-bold ms-1">
                7836996855
              </a>
            </p>
            <p>
              <a href="mailto:info@cartstudio.in" className="text-white">
                info@cartstudio.in
              </a>
            </p>
            <div className="social-links d-flex mt-4">
              <a href="#">
                <i className="bi bi-twitter"></i>
              </a>
              <a href="#">
                <i className="bi bi-facebook"></i>
              </a>
              <a href="#">
                <i className="bi bi-instagram"></i>
              </a>
              <a href="#">
                <i className="bi bi-linkedin"></i>
              </a>
            </div>
          </div>
          {/* End Footer About */}

          {/* Useful Links */}
          <div className="col-lg-2 col-md-6 footer-links">
            <h4>Useful Links</h4>
            <ul>
              <li>
                <i className="bi bi-chevron-right"></i> <a href="/">Home</a>
              </li>
              <li>
                <i className="bi bi-chevron-right"></i>{" "}
                <a href="/about">About us</a>
              </li>
              {/* <li>
                <i className="bi bi-chevron-right"></i>{" "}
                <a href="#services">Services</a>
              </li>
              <li>
                <i className="bi bi-chevron-right"></i>{" "}
                <a href="#portfolio">Portfolio</a>
              </li> */}
              <li>
                <i className="bi bi-chevron-right"></i>{" "}
                <a href="/contact">Contact</a>
              </li>
            </ul>
          </div>
          {/* End Useful Links */}

          {/* Our Services */}
          {/* <div className="col-lg-3 col-md-6 footer-links">
            <h4>Our Services</h4>
            <ul>
              <li>
                <i className="bi bi-chevron-right"></i>{" "}
                <a href="#">Web Design</a>
              </li>
              <li>
                <i className="bi bi-chevron-right"></i>{" "}
                <a href="#">Web Development</a>
              </li>
              <li>
                <i className="bi bi-chevron-right"></i>{" "}
                <a href="#">Product Management</a>
              </li>
              <li>
                <i className="bi bi-chevron-right"></i>{" "}
                <a href="#">Marketing</a>
              </li>
              <li>
                <i className="bi bi-chevron-right"></i>{" "}
                <a href="#">Graphic Design</a>
              </li>
            </ul>
          </div> */}
          {/* End Our Services */}

          {/* Newsletter */}
          {/* <div className="col-lg-3 col-md-6 footer-newsletter">
            <h4>Our Newsletter</h4>
            <p>
              Subscribe to our newsletter and receive the latest news about our
              products and services!
            </p>
            <form action="" method="post" className="php-email-form">
              <div className="newsletter-form d-flex">
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  placeholder="Enter your email"
                  required
                />
                <button type="submit">
                  <i className="bi bi-send"></i>
                </button>
              </div>
              <div className="loading">Loading</div>
              <div className="error-message"></div>
              <div className="sent-message">Thank you for subscribing!</div>
            </form>
          </div> */}
          {/* End Newsletter */}
        </div>
      </div>

      {/* <div className="container copyright text-center mt-4">
        <p>
          © <span>Copyright</span>{" "}
          <strong className="px-1 sitename">Cart Studio</strong>{" "}
          <span>All Rights Reserved</span>
        </p>
      </div> */}
      <div className="container text-center py-2">
        <div>
          {" "}
          © <span>Copyright</span>{" "}
          <strong className="px-1 sitename">Cart Studio</strong>{" "}
          <span>All Rights Reserved</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
